import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";

import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";

import grey from "@material-ui/core/colors/grey";
import { map } from "ramda";
import { notBlank } from "../../../util/ext";
import { Box } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  itemContent: {
    height: "auto",
    fontSize: "1.25rem",
    borderBottom: "solid",
    borderBottomColor: grey[200],
  },

  contentTitle: {
    fontSize: "1.75rem",
    fontWeight: "bold",
  },

  contentContainer: {
    width: "80%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "nowrap",
  },

  mainDetail: {
    "& div": {
      "& label": {
        fontWeight: "bold",
        paddingRight: "0.5em",
      },
    },
  },

  trackingDetail: {
    "& div": {
      width: "100%",
      padding: "0.5rem 0 0 0",
      margin: "0.1rem 0",
      whiteSpace: "normal",
      fontSize: "1.6rem",

      "& label": {
        fontWeight: "bold",
        paddingRight: "0.5em",
      },
    },
  },

  actionContainer: {
    "& button": {
      margin: "10px 0",
    },
  },
}));

const SipServerListItem = props => {
  const { server, selected, onEditClick, onDeleteClick } = props;
  const classes = useStyles();

  return (
    <ListItem
      selected={selected}
      classes={{ root: classes.itemContent }}
      key={server.sipServerId}
    >
      <ListItemText
        disableTypography={true}
        primary={
          <React.Fragment>
            <div className={classes.contentTitle}>{server.sipServerId}</div>
          </React.Fragment>
        }
        secondary={
          <React.Fragment>
            <div className={classes.contentContainer}>
              <div className={classes.mainDetail}>
                <div>
                  <label>Hostname:</label>
                  {server.hostname}
                </div>
                <div>
                  <label>Port:</label>
                  {server.port}
                </div>
                <div>
                  <label>Version:</label>
                  {server.version}
                </div>
              </div>
              <div className={classes.trackingDetail}>
                <div>
                  <div>
                    <label>Created By:</label>
                    {server.createdUser.username}
                  </div>
                  <div>
                    <label>Date Created:</label>
                    {server.dateCreated}
                  </div>
                </div>
                <div>
                  <div>
                    <label>Updated By:</label>
                    {server.updatedUser.username}
                  </div>
                  <div>
                    <label>Date Updated:</label>
                    {server.dateUpdated}
                  </div>
                </div>
              </div>
            </div>
            <div className={classes.mainDetail}>
              {notBlank(server.organizations) && (
                <div>
                  <label>Organizations:</label>
                  {map(
                    org => (
                      <Box
                        p={1}
                      >{`${org.organizationName} (${org.organizationId})`}</Box>
                    ),
                    server.organizations,
                  )}
                </div>
              )}
            </div>
          </React.Fragment>
        }
      />
      <ListItemSecondaryAction classes={{ root: classes.actionContainer }}>
        <IconButton
          autoFocus={selected}
          edge="end"
          aria-label="edit"
          onClick={() => onEditClick(server)}
        >
          <EditIcon />
        </IconButton>
        <IconButton
          edge="end"
          aria-label="delete"
          onClick={() => onDeleteClick(server)}
        >
          <DeleteIcon />
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

export default SipServerListItem;
